module.exports = __webpack_public_path__ + "img/Toss.59e560f6.svg";